// #region imports
// --- Angular
import { Injectable } from '@angular/core';
import { of, Observable } from 'rxjs';

// --- HS Code
import { SurveyBaseService } from './survey-base.service';
import {
  SortDirections,
  SurveyModel,
  SurveyResponseContexts,
  SurveyStatuses,
  SurveySummaryModel,
  SurveyResponseTypes
} from '../../../models';
import { AppService } from '../app.service';
import { ResponseBaseService } from './response-base.service';
import { ResultsBaseService } from '../results/results-base.service';
import { UserNotificationBaseService } from '../notifications/user-notification-base.service';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class SurveyMockService extends SurveyBaseService {
  private surveys: SurveyModel[];

  constructor(
    protected appService: AppService,
    protected responseService: ResponseBaseService,
    protected resultsService: ResultsBaseService,
    protected notificationService: UserNotificationBaseService
  ) {
    super(appService, responseService, resultsService, notificationService);
    this.surveys = new Array<SurveyModel>();
  }

  loadSummaries(
    pageSize: number,
    pageNumber: number,
    filter: string,
    sortItem: string,
    sortDirection: SortDirections
  ): void {
    if (filter) {
      this._selfSurveys$.next(new Array<SurveySummaryModel>());
    } else {
      const mySurveys = [
        {
          dateCreated: new Date(),
          id: '1',
          moniker: 'HSS1',
          name: '',
          numberOfOthers: 0,
          percentageOthersComplete: 0,
          percentageParticipantComplete: 0,
          status: SurveyStatuses.notStarted
        } as SurveySummaryModel
        // {
        //   dateCreated: new Date(),
        //   id: '2',
        //   moniker: 'HSS2',
        //   name: 'The completed one',
        //   numberOfOthers: 0,
        //   percentageOthersComplete: 0,
        //   percentageParticipantComplete: 100,
        //   status: SurveyStatuses.completeSurvey
        // } as SurveySummaryModel,
        // {
        //   dateCreated: new Date(),
        //   id: '3',
        //   moniker: 'HSS3',
        //   name: 'The incompleted one',
        //   numberOfOthers: 0,
        //   percentageOthersComplete: 0,
        //   percentageParticipantComplete: 35,
        //   status: SurveyStatuses.indicatorQuestions
        // } as SurveySummaryModel
      ];

      this._selfSurveys$.next(mySurveys);
      this._selectedSelfSurvey$.next(mySurveys[0]);
    }
  }

  loadSurveyById(id: string): void {
    const exists = this.surveys.find(s => {
      return s.moniker === id || s.id === id;
    });

    if (exists) {
      this._activeSurvey$.next(exists);
    }

    const survey = {} as SurveyModel;
    const newDate = new Date();
    survey.dateCreated = newDate;
    survey.dateLastUpdated = newDate;
    survey.id = 's1';
    survey.moniker = 'survey1';

    this._activeSurvey$.next(survey);
  }

  post(model: SurveyModel): Observable<SurveyModel> {
    const exists = this.surveys.find(s => {
      return s.name === model.name;
    });

    if (exists) {
      throw new Error('There is already a survey with that name');
    }

    const newSurvey = Object.assign({} as SurveyModel, model);
    const newDate = new Date();
    newSurvey.dateCreated = newDate;
    newSurvey.dateLastUpdated = newDate;
    newSurvey.id = 's1';
    newSurvey.moniker = model.name.toLowerCase().replace(/ /gi, '');

    this.surveys.push(newSurvey);

    return of(newSurvey);
  }

  update(model: SurveyModel): Observable<boolean> {
    const updated = Object.assign({} as SurveyModel, model);
    this._activeSurvey$.next(updated);
    return of(true);
  }
}
